import { render, staticRenderFns } from "./SaleEditSortRowsModal.vue?vue&type=template&id=1b57ed22&scoped=true"
import script from "./SaleEditSortRowsModal.vue?vue&type=script&lang=ts"
export * from "./SaleEditSortRowsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b57ed22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b57ed22')) {
      api.createRecord('1b57ed22', component.options)
    } else {
      api.reload('1b57ed22', component.options)
    }
    module.hot.accept("./SaleEditSortRowsModal.vue?vue&type=template&id=1b57ed22&scoped=true", function () {
      api.rerender('1b57ed22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditSortRowsModal.vue"
export default component.exports